import { css } from '@emotion/react';
import { AccessibleSVG } from '@core/svg';
/**
 * ChevronRight SVG Icon
 */
export const ChevronRight = (props) => {
    const { isRTL, fill, ...rest } = props;
    return (<AccessibleSVG width="100%" height="100%" viewBox="0 0 24 24" {...rest} css={css `
        ${isRTL ? 'transform: rotate(180deg);' : ''}
      `}>
      <path fill={fill ?? 'currentColor'} d="M9.29 6.71a.996.996 0 0 0 0 1.41L13.17 12l-3.88 3.88a.996.996 0 1 0 1.41 1.41l4.59-4.59a.996.996 0 0 0 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z"/>
    </AccessibleSVG>);
};
